import { createSelector } from 'reselect';
import PredesOriginImpcCodeNotRegisteredDetailsColumns from '../../containers/PredesOriginImpcCodeNotRegisteredDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesOriginImpcCodeNotRegisteredDetailsColumns);
